import React, { Component } from "react";
import { Row, Col, Form, Button, Card, message, Spin, Tag } from "antd";
import { Link } from "react-router-dom";
import CurrencyFormat from "react-currency-format";
import { connect } from "react-redux";
import ModalCreateSPK from "./Modal/ModalCreateSPK";
import Axios from "axios";
import axios from "../../../services/axios";
import { errorMessage } from "../../Utils";
import ModalConfirmation from "./Modal/ModalConfirmation";
import ModalDialog from "./Modal/ModalDialog";
import moment from "moment-timezone";
import ModalRejectApproval from "./Modal/ModalRejectApproval";

const FormItem = Form.Item;
let cancelToken;

class EApprovalDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showModal: false,
      showModalConfirmation: false,
      showModalDialog: false,
      rawData: null,
      modalCaption: "",
      successMessage: "",
      dataInfo: {
        dpp: "",
        salesRevenue: "",
        discountSubsidiDp: { discount: 0, priceTotal: 0 },
        discount: { discount: 0, priceTotal: 0 },
      },
    };
  }

  componentDidMount() {
    const { history } = this.props;
    this.fetchData(history.location.state.id);
  }

  async fetchData(id) {
    if (cancelToken) {
      cancelToken.cancel("Operation canceled due to new request");
    }
    cancelToken = Axios.CancelToken.source();

    await axios
      .get(`car-sales/${id}`)
      .then((result) => {
        this.setState({
          rawData: result.data.carSale,
          isLoading: false,
        });

        if (result.data) {
          this.convertDataCalculationDetail(result.data.carSale);
        }
      })
      .catch((err) => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
          this.setState({ isLoading: false });
        }
      });
  }

  convertDataCalculationDetail = (datas) => {
    let { dataInfo } = this.state;
    let salesRevenue;
    let dpp;
    let discountSubsidiDP;
    let discount;
    let kilometer;
    let stockDays;
    datas.calculationDetail &&
      datas.calculationDetail.map((item) => {
        switch (item.name) {
          case "Sales Revenue":
            salesRevenue = item.priceTotal;
            break;
          case "DPP":
            dpp = item.priceTotal;
            break;
          case "Discounts - Subsidi DP":
            discountSubsidiDP = item;
            break;
          case "Discounts":
            discount = item;
            break;
          case "Kilometer":
            kilometer = item.value;
            break;
          case "Stock Days":
            stockDays = item.value;
            break;
          default:
            break;
        }
      });

    this.setState({
      dataInfo: {
        ...dataInfo,
        salesRevenue,
        dpp,
        discountSubsidiDP,
        discount,
        kilometer,
        stockDays,
      },
    });
  };

  async handleAction(type, data) {
    this.setState({ showModal: false });
    switch (type) {
      case "spk":
        this.setState({
          modalCaption: "Apakah anda yakin data SPK sudah sesuai?",
        });
        break;
      default:
        this.setState({
          modalCaption:
            "Apakah anda yakin untuk menyetujui pembatalan pengajuan ini?",
        });
        break;
    }
    this.setState({
      showModalConfirmation: true,
      modalType: type,
      payload: data,
    });
  }

  async handleSubmit(type, cancelledNotes) {
    const { history } = this.props;
    const { payload } = this.state;
    let id = history.location.state.id;
    let datas = type === "create-spk" ? payload : { cancelledNotes };
    if (type === "create-spk") {
      if (
        datas.customerPhone &&
        datas.customerPhone[0] != "6" &&
        datas.customerPhone[1] != "2"
      ) {
        datas.customerPhone = "62" + datas.customerPhone;
      }
    }
    axios
      .patch(`/car-sales/${id}/${type}`, datas)
      .then((result) => {
        // message.success(`Berhasil membatalkan approval`);
        this.setState({
          showModalReject: false,
          showModalDialog: true,
          successMessage:
            type === "create-spk"
              ? "SPK Successfully Created"
              : "Pengajuan Diskon Berhasil Dibatalkan",
        });
      })
      .catch((err) => {
        this.errorMessage(err);
      });
  }

  callback(key, props) {
    props.form.resetFields();
  }

  errorMessage(e) {
    if (e.response) {
      if (e.response.data || e.response.message) {
        message.error(
          e.response.data.message || e.response.message || e.response.data
        );
      } else {
        message.error("Error Get Approval");
      }
    } else {
      message.error("Error Get Approval");
    }
  }

  render() {
    const { history, Auth } = this.props;
    const {
      showModal,
      showModalConfirmation,
      showModalDialog,
      showModalReject,
      rawData,
      modalCaption,
      modalType,
      successMessage,
      dataInfo,
    } = this.state;
    return (
      <div>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={16} style={{ marginTop: 35 }}>
            {rawData && rawData.status.includes("SPK") ? (
              <Card title="Detail Pengajuan SPK" style={{ marginBottom: 20 }}>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                  <Col className="gutter-row" span={12}>
                    <Link to={"/home/e-approval/selling-system"}>
                      <p>Back to List</p>
                    </Link>
                  </Col>
                  {rawData && rawData.status === "SPK" ? (
                    <Col
                      className="gutter-row"
                      span={12}
                      style={{ textAlign: "right" }}>
                      <Tag color="gold">{rawData ? rawData.status : "-"}</Tag>
                    </Col>
                  ) : null}
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                  <Col className="gutter-row" span={12}>
                    <FormItem label="Name" style={{ marginBottom: 0 }}>
                      <p>{rawData ? rawData.customerName : "-"}</p>
                    </FormItem>
                    <FormItem label="NIK" style={{ marginBottom: 0 }}>
                      <p>{rawData ? rawData.customerNIK : "-"}</p>
                    </FormItem>
                    <FormItem label="NPWP" style={{ marginBottom: 0 }}>
                      <p>{rawData ? rawData.customerNPWP : "-"}</p>
                    </FormItem>
                    <FormItem label="Mobile Phone" style={{ marginBottom: 0 }}>
                      <p>+{rawData ? rawData.customerPhone : "-"}</p>
                    </FormItem>
                    <FormItem
                      label="Payment Option"
                      style={{ marginBottom: 0 }}>
                      <p>
                        {rawData && rawData.paymentOption
                          ? rawData.paymentOption
                          : "-"}
                      </p>
                    </FormItem>
                    <FormItem label="Sales Type" style={{ marginBottom: 0 }}>
                      <p>{(rawData && rawData.salesType) || "-"}</p>
                    </FormItem>
                  </Col>
                  <Col className="gutter-row" span={12}>
                    <FormItem label="Country" style={{ marginBottom: 0 }}>
                      <p>{(rawData && rawData.countryName) || "-"}</p>
                    </FormItem>
                    <FormItem label="Province" style={{ marginBottom: 0 }}>
                      <p>{(rawData && rawData.provinceName) || "-"}</p>
                    </FormItem>
                    <FormItem label="City" style={{ marginBottom: 0 }}>
                      <p>{(rawData && rawData.cityName) || "-"}</p>
                    </FormItem>
                    <FormItem label="Postal Code" style={{ marginBottom: 0 }}>
                      <p>{(rawData && rawData.postalCode) || "-"}</p>
                    </FormItem>
                    <FormItem label="Alamat" style={{ marginBottom: 0 }}>
                      <p>{(rawData && rawData.customerAddress) || "-"}</p>
                    </FormItem>
                  </Col>
                </Row>
              </Card>
            ) : null}

            <Card title="Detail Pengajuan Diskon">
              <Spin
                tip="Sedang membatalkan pengajuan diskon"
                spinning={this.state.isLoading}>
                <Form>
                  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={12}>
                      <Link to={"/home/e-approval/selling-system"}>
                        <p>Back to List</p>
                      </Link>
                    </Col>
                    <Col className="gutter-row" span={12}>
                      <h4 style={{ textAlign: "right" }}>
                        Stock Days:{" "}
                        {rawData && rawData.odooPayload
                          ? rawData.odooPayload.data.stock_days
                          : 0}
                      </h4>
                      <h4 style={{ textAlign: "right", fontWeight: "normal" }}>
                        Km:{" "}
                        <CurrencyFormat
                          value={
                            dataInfo && dataInfo.kilometer
                              ? dataInfo.kilometer
                              : 0
                          }
                          displayType={"text"}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                        />
                      </h4>
                    </Col>
                  </Row>
                  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={8}>
                      <FormItem label="Nama Unit">
                        <p>{rawData ? rawData.carName : "No Data"}</p>
                      </FormItem>
                    </Col>
                    <Col className="gutter-row" span={8}>
                      <FormItem label="Cabang">
                        <p>
                          {rawData
                            ? rawData.SalesProfile.SalesBranch.branch
                            : "No Data"}
                        </p>
                      </FormItem>
                    </Col>
                    <Col className="gutter-row" span={8}>
                      <FormItem label="No Polisi">
                        <p>{rawData ? rawData.licensePlate : "No Data"}</p>
                      </FormItem>
                    </Col>
                  </Row>

                  <div
                    style={{
                      borderRadius: 10,
                      backgroundColor: "#EFF2F5",
                      padding: 15,
                    }}>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                      <Col className="gutter-row" span={12}>
                        <div>
                          <h4>OTR</h4>
                          <h4>Sales Revenue</h4>
                          {/*<h4>DPP</h4>*/}
                        </div>
                      </Col>
                      <Col className="gutter-row" span={12}>
                        <div style={{ textAlign: "right" }}>
                          <h4>
                            <CurrencyFormat
                              style={{ fontWeight: "normal" }}
                              value={rawData ? rawData.otr : 0}
                              displayType={"text"}
                              decimalSeparator={","}
                              thousandSeparator={"."}
                              prefix={"Rp "}
                            />
                          </h4>
                          <h4>
                            <CurrencyFormat
                              style={{ fontWeight: "normal" }}
                              value={
                                dataInfo && dataInfo.salesRevenue
                                  ? dataInfo.salesRevenue
                                  : 0
                              }
                              displayType={"text"}
                              decimalSeparator={","}
                              thousandSeparator={"."}
                              prefix={"Rp "}
                            />
                          </h4>
                          {/*<h4><CurrencyFormat style={{fontWeight: "normal"}} value={dataInfo && dataInfo.dpp ? dataInfo.dpp : 0} displayType={'text'} decimalSeparator={","} thousandSeparator={"."} prefix={"Rp "} /></h4>*/}
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div style={{ margin: 20 }}>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                      <Col className="gutter-row" span={12}>
                        <div style={{ marginBottom: 5 }}>
                          Discounts - Subsidi DP
                        </div>
                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                          <Col className="gutter-row" span={8}>
                            <div style={{ display: "flex" }}>
                              <CurrencyFormat
                                style={{
                                  border: "1px solid #d9d9d9",
                                  borderRadius: 5,
                                  width: "100%",
                                  padding: "0 10px",
                                }}
                                value={
                                  dataInfo && dataInfo.discountSubsidiDP
                                    ? dataInfo.discountSubsidiDP.discount
                                      ? dataInfo.discountSubsidiDP.discount
                                      : 0
                                    : 0
                                }
                                thousandSeparator={"."}
                                decimalSeparator={","}
                                disabled={true}
                                placeholder={"Diskon"}
                              />
                              <div style={{ padding: 10, marginLeft: -30 }}>
                                %
                              </div>
                            </div>
                          </Col>
                          <Col className="gutter-row" span={16}>
                            <div style={{ display: "flex" }}>
                              <div
                                style={{
                                  padding: 10,
                                  backgroundColor: "#f5f5f5",
                                  borderRadius: "5px 0px 0px 5px",
                                }}>
                                Rp.
                              </div>
                              <CurrencyFormat
                                style={{
                                  border: "1px solid #d9d9d9",
                                  borderRadius: "0px 5px 5px 0px",
                                  width: "100%",
                                  padding: "0 10px",
                                }}
                                value={
                                  dataInfo && dataInfo.discountSubsidiDP
                                    ? dataInfo.discountSubsidiDP.priceTotal
                                      ? dataInfo.discountSubsidiDP.priceTotal
                                      : 0
                                    : 0
                                }
                                thousandSeparator={"."}
                                decimalSeparator={","}
                                disabled={true}
                                placeholder={"00,00"}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col className="gutter-row" span={12}>
                        <div style={{ marginBottom: 5 }}>Discounts</div>
                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                          <Col className="gutter-row" span={8}>
                            <div style={{ display: "flex" }}>
                              <CurrencyFormat
                                style={{
                                  border: "1px solid #d9d9d9",
                                  borderRadius: 5,
                                  width: "100%",
                                  padding: "0 10px",
                                }}
                                value={
                                  dataInfo && dataInfo.discount
                                    ? dataInfo.discount.discount
                                      ? dataInfo.discount.discount
                                      : 0
                                    : 0
                                }
                                thousandSeparator={"."}
                                decimalSeparator={","}
                                disabled={true}
                                placeholder={"7,88"}
                              />
                              <div style={{ padding: 10, marginLeft: -30 }}>
                                %
                              </div>
                            </div>
                          </Col>
                          <Col className="gutter-row" span={16}>
                            <div style={{ display: "flex" }}>
                              <div
                                style={{
                                  padding: 10,
                                  backgroundColor: "#f5f5f5",
                                  borderRadius: "5px 0px 0px 5px",
                                }}>
                                Rp.
                              </div>
                              <CurrencyFormat
                                style={{
                                  border: "1px solid #d9d9d9",
                                  borderRadius: "0px 5px 5px 0px",
                                  width: "100%",
                                  padding: "0 10px",
                                }}
                                value={
                                  dataInfo && dataInfo.discount
                                    ? dataInfo.discount.priceTotal
                                      ? dataInfo.discount.priceTotal
                                      : 0
                                    : 0
                                }
                                thousandSeparator={"."}
                                decimalSeparator={","}
                                disabled={true}
                                placeholder={"17.000.000"}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  <FormItem label="Sales Notes" style={{ marginBottom: 0 }}>
                    <p>{rawData ? rawData.salesNotes : "-"}</p>
                  </FormItem>
                  {rawData &&
                    rawData.status === "Approved" &&
                    rawData.spkNotes && (
                      <FormItem
                        label="Alasan Penolakan SPK"
                        style={{ marginBottom: 0 }}>
                        <p>{rawData ? rawData.spkNotes : "-"}</p>
                      </FormItem>
                    )}
                  {(rawData && rawData.status === "Cancel") ||
                  (rawData && rawData.status.includes("Reject")) ? (
                    <FormItem label="Alasan Penolakan">
                      <p>
                        {rawData
                          ? rawData.status === "Cancel"
                            ? rawData.cancelledNotes
                            : rawData.status === "Reject"
                            ? rawData.rejectedNotes
                            : rawData.spkNotes
                          : "-"}
                      </p>
                    </FormItem>
                  ) : null}

                  {Auth.user.role === "SALES_USER" &&
                  ((rawData && rawData.status === "New") ||
                    (rawData && rawData.status.includes("Waiting")) ||
                    (rawData && rawData.status === "Approved")) ? (
                    <Row type="flex" justify="end">
                      <Col>
                        {rawData && rawData.status === "Approved" && (
                          <Button
                            htmlType="button"
                            type={"danger"}
                            style={{ marginRight: 10 }}
                            onClick={() =>
                              this.setState({ showModalReject: true })
                            }>
                            Cancel
                          </Button>
                        )}

                        <Button
                          htmlType="button"
                          type={
                            rawData && rawData.status === "Approved"
                              ? "primary"
                              : "danger"
                          }
                          onClick={() =>
                            rawData && rawData.status === "Approved"
                              ? this.setState({ showModal: true })
                              : this.setState({ showModalReject: true })
                          }>
                          {rawData && rawData.status === "Approved"
                            ? "Create SPK"
                            : "Cancel"}
                        </Button>
                      </Col>
                    </Row>
                  ) : null}
                </Form>
              </Spin>

              <ModalRejectApproval
                type={"cancel"}
                showModal={showModalReject}
                id={history.location.state.id}
                toggleShowModal={(value) =>
                  this.setState({ showModalReject: value })
                }
                actionModal={(type, data) => this.handleSubmit(type, data)}
              />

              {rawData && (
                <ModalCreateSPK
                  rawData={rawData}
                  showModal={showModal}
                  handleAction={(data) => this.handleAction("spk", data)}
                  toggleShowModal={(value) =>
                    this.setState({ showModal: value })
                  }
                />
              )}

              <ModalConfirmation
                showModal={showModalConfirmation}
                title={
                  modalType === "spk"
                    ? "Submit Pengajuan SPK"
                    : "Cancel Pengajuan Diskon"
                }
                buttonText={"Ya"}
                buttonTextCancel={"Tidak"}
                caption={modalCaption}
                toggleShowModal={(value) =>
                  this.setState({ showModalConfirmation: value })
                }
                handleAction={() =>
                  this.handleSubmit(
                    modalType === "spk" ? "create-spk" : "cancel"
                  )
                }
              />

              <ModalDialog
                showModal={showModalDialog}
                caption={successMessage}
                toggleShowModal={(value) => {
                  this.setState({ showModalDialog: value });
                  this.props.history.push(`/home/e-approval/selling-system`);
                }}
              />
            </Card>
          </Col>
          <Col className="gutter-row" span={8} style={{ marginTop: 35 }}>
            <Card title="Audit Trail">
              <div>
                <h4>Tanggal Pengajuan Diskon</h4>
                <h4 style={{ fontWeight: "normal" }}>
                  {rawData
                    ? moment(rawData.createdAt).format("DD/MM/YYYY (HH:mm:ss)")
                    : "-"}
                </h4>
              </div>
              {rawData && rawData.status === "Reject" ? (
                <div>
                  <h4>Tanggal Penolakan Diskon</h4>
                  <h4 style={{ fontWeight: "normal" }}>
                    {rawData && rawData.rejectedAt
                      ? moment(rawData.rejectedAt).format(
                          "DD/MM/YYYY (HH:mm:ss)"
                        )
                      : "-"}
                  </h4>
                </div>
              ) : null}
              {rawData && rawData.status === "Cancel" ? (
                <div>
                  <h4>Tanggal Pembatalan Diskon</h4>
                  <h4 style={{ fontWeight: "normal" }}>
                    {rawData
                      ? moment(rawData.cancelledAt).format(
                          "DD/MM/YYYY (HH:mm:ss)"
                        )
                      : "-"}
                  </h4>
                </div>
              ) : null}
              {(rawData && rawData.status === "SPK") ||
              (rawData && rawData.status === "Approved") ||
              (rawData && rawData.status === "Done") ||
              (rawData && rawData.status === "SPK Reject") ? (
                <div>
                  <h4>Tanggal Approve Diskon</h4>
                  <h4 style={{ fontWeight: "normal" }}>
                    {rawData
                      ? moment(rawData.completionAt).format(
                          "DD/MM/YYYY (HH:mm:ss)"
                        )
                      : "-"}
                  </h4>
                </div>
              ) : null}

              {rawData &&
              rawData.status === "Approved" &&
              rawData.spkRejectedAt != null ? (
                <div>
                  <div>
                    <h4>Tanggal Pembuatan SPK</h4>
                    <h4 style={{ fontWeight: "normal" }}>
                      {rawData && rawData.spkRequestAt
                        ? moment(rawData.spkRequestAt).format(
                            "DD/MM/YYYY (HH:mm:ss)"
                          )
                        : "-"}
                    </h4>
                  </div>
                  <div>
                    <h4>Tanggal Penolakan SPK</h4>
                    <h4 style={{ fontWeight: "normal" }}>
                      {rawData && rawData.spkRejectedAt
                        ? moment(rawData.spkRejectedAt).format(
                            "DD/MM/YYYY (HH:mm:ss)"
                          )
                        : "-"}
                    </h4>
                  </div>
                </div>
              ) : null}

              {(rawData && rawData.status === "SPK") ||
              (rawData && rawData.status === "Done") ||
              (rawData && rawData.status === "SPK Reject") ? (
                <div>
                  <h4>Tanggal Pembuatan SPK</h4>
                  <h4 style={{ fontWeight: "normal" }}>
                    {rawData && rawData.spkRequestAt
                      ? moment(rawData.spkRequestAt).format(
                          "DD/MM/YYYY (HH:mm:ss)"
                        )
                      : "-"}
                  </h4>
                </div>
              ) : null}

              {rawData && rawData.status === "Done" ? (
                <div>
                  <h4>Tanggal Approve SPK</h4>
                  <h4 style={{ fontWeight: "normal" }}>
                    {rawData && rawData.spkApprovedAt
                      ? moment(rawData.spkApprovedAt).format(
                          "DD/MM/YYYY (HH:mm:ss)"
                        )
                      : "-"}
                  </h4>
                </div>
              ) : null}

              {rawData && rawData.status === "SPK Reject" ? (
                <div>
                  <h4>Tanggal Penolakan SPK</h4>
                  <h4 style={{ fontWeight: "normal" }}>
                    {rawData && rawData.spkRejectedAt
                      ? moment(rawData.spkRejectedAt).format(
                          "DD/MM/YYYY (HH:mm:ss)"
                        )
                      : "-"}
                  </h4>
                </div>
              ) : null}
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

let mapStateToProps = ({ Auth }) => ({ Auth });

export default Form.create()(connect(mapStateToProps)(EApprovalDetail));



// WEBPACK FOOTER //
// src/components/Dashboard/EApproval/EApprovalDetail.js